module.exports = __webpack_public_path__ + "img/2Reihe_3.bc487e17.jpg";